import React from 'react';

export enum TYPES {
    H1 = 'h1',
    H2 = 'h2',
    H3 = 'h3',
    H4 = 'h4',
}

export interface TitleProps {
    children: React.ReactChildren | string | React.ComponentElement<any, any>
    type: TYPES
}

export class Title extends React.Component<TitleProps> {}
